function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module utils/observablemixin
 */
import EmitterMixin from './emittermixin';
import CKEditorError from './ckeditorerror';
import { extend, isObject } from 'lodash-es';
var observablePropertiesSymbol = Symbol('observableProperties');
var boundObservablesSymbol = Symbol('boundObservables');
var boundPropertiesSymbol = Symbol('boundProperties');

var _decoratedMethods = Symbol('decoratedMethods');

var _decoratedOriginal = Symbol('decoratedOriginal');
/**
 * A mixin that injects the "observable properties" and data binding functionality described in the
 * {@link ~Observable} interface.
 *
 * Read more about the concept of observables in the:
 * * {@glink framework/guides/architecture/core-editor-architecture#event-system-and-observables "Event system and observables"}
 * section of the {@glink framework/guides/architecture/core-editor-architecture "Core editor architecture"} guide,
 * * {@glink framework/guides/deep-dive/observables "Observables" deep dive} guide.
 *
 * @mixin ObservableMixin
 * @mixes module:utils/emittermixin~EmitterMixin
 * @implements module:utils/observablemixin~Observable
 */


var ObservableMixin = {
  /**
   * @inheritDoc
   */
  set: function set(name, value) {
    var _this = this;

    // If the first parameter is an Object, iterate over its properties.
    if (isObject(name)) {
      Object.keys(name).forEach(function (property) {
        _this.set(property, name[property]);
      }, this);
      return;
    }

    initObservable(this);
    var properties = this[observablePropertiesSymbol];

    if (name in this && !properties.has(name)) {
      /**
       * Cannot override an existing property.
       *
       * This error is thrown when trying to {@link ~Observable#set set} a property with
       * a name of an already existing property. For example:
       *
       *		let observable = new Model();
       *		observable.property = 1;
       *		observable.set( 'property', 2 );			// throws
       *
       *		observable.set( 'property', 1 );
       *		observable.set( 'property', 2 );			// ok, because this is an existing property.
       *
       * @error observable-set-cannot-override
       */
      throw new CKEditorError('observable-set-cannot-override', this);
    }

    Object.defineProperty(this, name, {
      enumerable: true,
      configurable: true,
      get: function get() {
        return properties.get(name);
      },
      set: function set(value) {
        var oldValue = properties.get(name); // Fire `set` event before the new value will be set to make it possible
        // to override observable property without affecting `change` event.
        // See https://github.com/ckeditor/ckeditor5-utils/issues/171.

        var newValue = this.fire('set:' + name, name, value, oldValue);

        if (newValue === undefined) {
          newValue = value;
        } // Allow undefined as an initial value like A.define( 'x', undefined ) (#132).
        // Note: When properties map has no such own property, then its value is undefined.


        if (oldValue !== newValue || !properties.has(name)) {
          properties.set(name, newValue);
          this.fire('change:' + name, name, newValue, oldValue);
        }
      }
    });
    this[name] = value;
  },

  /**
   * @inheritDoc
   */
  bind: function bind() {
    var _this2 = this;

    for (var _len = arguments.length, bindProperties = new Array(_len), _key = 0; _key < _len; _key++) {
      bindProperties[_key] = arguments[_key];
    }

    if (!bindProperties.length || !isStringArray(bindProperties)) {
      /**
       * All properties must be strings.
       *
       * @error observable-bind-wrong-properties
       */
      throw new CKEditorError('observable-bind-wrong-properties', this);
    }

    if (new Set(bindProperties).size !== bindProperties.length) {
      /**
       * Properties must be unique.
       *
       * @error observable-bind-duplicate-properties
       */
      throw new CKEditorError('observable-bind-duplicate-properties', this);
    }

    initObservable(this);
    var boundProperties = this[boundPropertiesSymbol];
    bindProperties.forEach(function (propertyName) {
      if (boundProperties.has(propertyName)) {
        /**
         * Cannot bind the same property more than once.
         *
         * @error observable-bind-rebind
         */
        throw new CKEditorError('observable-bind-rebind', _this2);
      }
    });
    var bindings = new Map(); // @typedef {Object} Binding
    // @property {Array} property Property which is bound.
    // @property {Array} to Array of observable–property components of the binding (`{ observable: ..., property: .. }`).
    // @property {Array} callback A function which processes `to` components.

    bindProperties.forEach(function (a) {
      var binding = {
        property: a,
        to: []
      };
      boundProperties.set(a, binding);
      bindings.set(a, binding);
    }); // @typedef {Object} BindChain
    // @property {Function} to See {@link ~ObservableMixin#_bindTo}.
    // @property {Function} toMany See {@link ~ObservableMixin#_bindToMany}.
    // @property {module:utils/observablemixin~Observable} _observable The observable which initializes the binding.
    // @property {Array} _bindProperties Array of `_observable` properties to be bound.
    // @property {Array} _to Array of `to()` observable–properties (`{ observable: toObservable, properties: ...toProperties }`).
    // @property {Map} _bindings Stores bindings to be kept in
    // {@link ~ObservableMixin#_boundProperties}/{@link ~ObservableMixin#_boundObservables}
    // initiated in this binding chain.

    return {
      to: bindTo,
      toMany: bindToMany,
      _observable: this,
      _bindProperties: bindProperties,
      _to: [],
      _bindings: bindings
    };
  },

  /**
   * @inheritDoc
   */
  unbind: function unbind() {
    var _this3 = this;

    // Nothing to do here if not inited yet.
    if (!this[observablePropertiesSymbol]) {
      return;
    }

    var boundProperties = this[boundPropertiesSymbol];
    var boundObservables = this[boundObservablesSymbol];

    for (var _len2 = arguments.length, unbindProperties = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      unbindProperties[_key2] = arguments[_key2];
    }

    if (unbindProperties.length) {
      if (!isStringArray(unbindProperties)) {
        /**
         * Properties must be strings.
         *
         * @error observable-unbind-wrong-properties
         */
        throw new CKEditorError('observable-unbind-wrong-properties', this);
      }

      unbindProperties.forEach(function (propertyName) {
        var binding = boundProperties.get(propertyName); // Nothing to do if the binding is not defined

        if (!binding) {
          return;
        }

        var toObservable, toProperty, toProperties, toPropertyBindings;
        binding.to.forEach(function (to) {
          // TODO: ES6 destructuring.
          toObservable = to[0];
          toProperty = to[1];
          toProperties = boundObservables.get(toObservable);
          toPropertyBindings = toProperties[toProperty];
          toPropertyBindings.delete(binding);

          if (!toPropertyBindings.size) {
            delete toProperties[toProperty];
          }

          if (!Object.keys(toProperties).length) {
            boundObservables.delete(toObservable);

            _this3.stopListening(toObservable, 'change');
          }
        });
        boundProperties.delete(propertyName);
      });
    } else {
      boundObservables.forEach(function (bindings, boundObservable) {
        _this3.stopListening(boundObservable, 'change');
      });
      boundObservables.clear();
      boundProperties.clear();
    }
  },

  /**
   * @inheritDoc
   */
  decorate: function decorate(methodName) {
    var _this4 = this;

    var originalMethod = this[methodName];

    if (!originalMethod) {
      /**
       * Cannot decorate an undefined method.
       *
       * @error observablemixin-cannot-decorate-undefined
       * @param {Object} object The object which method should be decorated.
       * @param {String} methodName Name of the method which does not exist.
       */
      throw new CKEditorError('observablemixin-cannot-decorate-undefined', this, {
        object: this,
        methodName: methodName
      });
    }

    this.on(methodName, function (evt, args) {
      evt.return = originalMethod.apply(_this4, args);
    });

    this[methodName] = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.fire(methodName, args);
    };

    this[methodName][_decoratedOriginal] = originalMethod;

    if (!this[_decoratedMethods]) {
      this[_decoratedMethods] = [];
    }

    this[_decoratedMethods].push(methodName);
  }
};
extend(ObservableMixin, EmitterMixin); // Override the EmitterMixin stopListening method to be able to clean (and restore) decorated methods.
// This is needed in case of:
//  1. Have x.foo() decorated.
//  2. Call x.stopListening()
//  3. Call x.foo(). Problem: nothing happens (the original foo() method is not executed)

ObservableMixin.stopListening = function (emitter, event, callback) {
  // Removing all listeners so let's clean the decorated methods to the original state.
  if (!emitter && this[_decoratedMethods]) {
    var _iterator = _createForOfIteratorHelper(this[_decoratedMethods]),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var methodName = _step.value;
        this[methodName] = this[methodName][_decoratedOriginal];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    delete this[_decoratedMethods];
  }

  EmitterMixin.stopListening.call(this, emitter, event, callback);
};

export default ObservableMixin; // Init symbol properties needed for the observable mechanism to work.
//
// @private
// @param {module:utils/observablemixin~ObservableMixin} observable

function initObservable(observable) {
  // Do nothing if already inited.
  if (observable[observablePropertiesSymbol]) {
    return;
  } // The internal hash containing the observable's state.
  //
  // @private
  // @type {Map}


  Object.defineProperty(observable, observablePropertiesSymbol, {
    value: new Map()
  }); // Map containing bindings to external observables. It shares the binding objects
  // (`{ observable: A, property: 'a', to: ... }`) with {@link module:utils/observablemixin~ObservableMixin#_boundProperties} and
  // it is used to observe external observables to update own properties accordingly.
  // See {@link module:utils/observablemixin~ObservableMixin#bind}.
  //
  //		A.bind( 'a', 'b', 'c' ).to( B, 'x', 'y', 'x' );
  //		console.log( A._boundObservables );
  //
  //			Map( {
  //				B: {
  //					x: Set( [
  //						{ observable: A, property: 'a', to: [ [ B, 'x' ] ] },
  //						{ observable: A, property: 'c', to: [ [ B, 'x' ] ] }
  //					] ),
  //					y: Set( [
  //						{ observable: A, property: 'b', to: [ [ B, 'y' ] ] },
  //					] )
  //				}
  //			} )
  //
  //		A.bind( 'd' ).to( B, 'z' ).to( C, 'w' ).as( callback );
  //		console.log( A._boundObservables );
  //
  //			Map( {
  //				B: {
  //					x: Set( [
  //						{ observable: A, property: 'a', to: [ [ B, 'x' ] ] },
  //						{ observable: A, property: 'c', to: [ [ B, 'x' ] ] }
  //					] ),
  //					y: Set( [
  //						{ observable: A, property: 'b', to: [ [ B, 'y' ] ] },
  //					] ),
  //					z: Set( [
  //						{ observable: A, property: 'd', to: [ [ B, 'z' ], [ C, 'w' ] ], callback: callback }
  //					] )
  //				},
  //				C: {
  //					w: Set( [
  //						{ observable: A, property: 'd', to: [ [ B, 'z' ], [ C, 'w' ] ], callback: callback }
  //					] )
  //				}
  //			} )
  //
  // @private
  // @type {Map}

  Object.defineProperty(observable, boundObservablesSymbol, {
    value: new Map()
  }); // Object that stores which properties of this observable are bound and how. It shares
  // the binding objects (`{ observable: A, property: 'a', to: ... }`) with
  // {@link module:utils/observablemixin~ObservableMixin#_boundObservables}. This data structure is
  // a reverse of {@link module:utils/observablemixin~ObservableMixin#_boundObservables} and it is helpful for
  // {@link module:utils/observablemixin~ObservableMixin#unbind}.
  //
  // See {@link module:utils/observablemixin~ObservableMixin#bind}.
  //
  //		A.bind( 'a', 'b', 'c' ).to( B, 'x', 'y', 'x' );
  //		console.log( A._boundProperties );
  //
  //			Map( {
  //				a: { observable: A, property: 'a', to: [ [ B, 'x' ] ] },
  //				b: { observable: A, property: 'b', to: [ [ B, 'y' ] ] },
  //				c: { observable: A, property: 'c', to: [ [ B, 'x' ] ] }
  //			} )
  //
  //		A.bind( 'd' ).to( B, 'z' ).to( C, 'w' ).as( callback );
  //		console.log( A._boundProperties );
  //
  //			Map( {
  //				a: { observable: A, property: 'a', to: [ [ B, 'x' ] ] },
  //				b: { observable: A, property: 'b', to: [ [ B, 'y' ] ] },
  //				c: { observable: A, property: 'c', to: [ [ B, 'x' ] ] },
  //				d: { observable: A, property: 'd', to: [ [ B, 'z' ], [ C, 'w' ] ], callback: callback }
  //			} )
  //
  // @private
  // @type {Map}

  Object.defineProperty(observable, boundPropertiesSymbol, {
    value: new Map()
  });
} // A chaining for {@link module:utils/observablemixin~ObservableMixin#bind} providing `.to()` interface.
//
// @private
// @param {...[Observable|String|Function]} args Arguments of the `.to( args )` binding.


function bindTo() {
  var _this5 = this;

  var parsedArgs = parseBindToArgs.apply(void 0, arguments);
  var bindingsKeys = Array.from(this._bindings.keys());
  var numberOfBindings = bindingsKeys.length; // Eliminate A.bind( 'x' ).to( B, C )

  if (!parsedArgs.callback && parsedArgs.to.length > 1) {
    /**
     * Binding multiple observables only possible with callback.
     *
     * @error observable-bind-to-no-callback
     */
    throw new CKEditorError('observable-bind-to-no-callback', this);
  } // Eliminate A.bind( 'x', 'y' ).to( B, callback )


  if (numberOfBindings > 1 && parsedArgs.callback) {
    /**
     * Cannot bind multiple properties and use a callback in one binding.
     *
     * @error observable-bind-to-extra-callback
     */
    throw new CKEditorError('observable-bind-to-extra-callback', this);
  }

  parsedArgs.to.forEach(function (to) {
    // Eliminate A.bind( 'x', 'y' ).to( B, 'a' )
    if (to.properties.length && to.properties.length !== numberOfBindings) {
      /**
       * The number of properties must match.
       *
       * @error observable-bind-to-properties-length
       */
      throw new CKEditorError('observable-bind-to-properties-length', _this5);
    } // When no to.properties specified, observing source properties instead i.e.
    // A.bind( 'x', 'y' ).to( B ) -> Observe B.x and B.y


    if (!to.properties.length) {
      to.properties = _this5._bindProperties;
    }
  });
  this._to = parsedArgs.to; // Fill {@link BindChain#_bindings} with callback. When the callback is set there's only one binding.

  if (parsedArgs.callback) {
    this._bindings.get(bindingsKeys[0]).callback = parsedArgs.callback;
  }

  attachBindToListeners(this._observable, this._to); // Update observable._boundProperties and observable._boundObservables.

  updateBindToBound(this); // Set initial values of bound properties.

  this._bindProperties.forEach(function (propertyName) {
    updateBoundObservableProperty(_this5._observable, propertyName);
  });
} // Binds to an attribute in a set of iterable observables.
//
// @private
// @param {Array.<Observable>} observables
// @param {String} attribute
// @param {Function} callback


function bindToMany(observables, attribute, callback) {
  if (this._bindings.size > 1) {
    /**
     * Binding one attribute to many observables only possible with one attribute.
     *
     * @error observable-bind-to-many-not-one-binding
     */
    throw new CKEditorError('observable-bind-to-many-not-one-binding', this);
  }

  this.to.apply(this, _toConsumableArray(getBindingTargets(observables, attribute)).concat([// ...using given callback to parse attribute values.
  callback]));
} // Returns an array of binding components for
// {@link Observable#bind} from a set of iterable observables.
//
// @param {Array.<Observable>} observables
// @param {String} attribute
// @returns {Array.<String|Observable>}


function getBindingTargets(observables, attribute) {
  var observableAndAttributePairs = observables.map(function (observable) {
    return [observable, attribute];
  }); // Merge pairs to one-dimension array of observables and attributes.

  return Array.prototype.concat.apply([], observableAndAttributePairs);
} // Check if all entries of the array are of `String` type.
//
// @private
// @param {Array} arr An array to be checked.
// @returns {Boolean}


function isStringArray(arr) {
  return arr.every(function (a) {
    return typeof a == 'string';
  });
} // Parses and validates {@link Observable#bind}`.to( args )` arguments and returns
// an object with a parsed structure. For example
//
//		A.bind( 'x' ).to( B, 'a', C, 'b', call );
//
// becomes
//
//		{
//			to: [
//				{ observable: B, properties: [ 'a' ] },
//				{ observable: C, properties: [ 'b' ] },
//			],
//			callback: call
// 		}
//
// @private
// @param {...*} args Arguments of {@link Observable#bind}`.to( args )`.
// @returns {Object}


function parseBindToArgs() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  // Eliminate A.bind( 'x' ).to()
  if (!args.length) {
    /**
     * Invalid argument syntax in `to()`.
     *
     * @error observable-bind-to-parse-error
     */
    throw new CKEditorError('observable-bind-to-parse-error', null);
  }

  var parsed = {
    to: []
  };
  var lastObservable;

  if (typeof args[args.length - 1] == 'function') {
    parsed.callback = args.pop();
  }

  args.forEach(function (a) {
    if (typeof a == 'string') {
      lastObservable.properties.push(a);
    } else if (_typeof(a) == 'object') {
      lastObservable = {
        observable: a,
        properties: []
      };
      parsed.to.push(lastObservable);
    } else {
      throw new CKEditorError('observable-bind-to-parse-error', null);
    }
  });
  return parsed;
} // Synchronizes {@link module:utils/observablemixin#_boundObservables} with {@link Binding}.
//
// @private
// @param {Binding} binding A binding to store in {@link Observable#_boundObservables}.
// @param {Observable} toObservable A observable, which is a new component of `binding`.
// @param {String} toPropertyName A name of `toObservable`'s property, a new component of the `binding`.


function updateBoundObservables(observable, binding, toObservable, toPropertyName) {
  var boundObservables = observable[boundObservablesSymbol];
  var bindingsToObservable = boundObservables.get(toObservable);
  var bindings = bindingsToObservable || {};

  if (!bindings[toPropertyName]) {
    bindings[toPropertyName] = new Set();
  } // Pass the binding to a corresponding Set in `observable._boundObservables`.


  bindings[toPropertyName].add(binding);

  if (!bindingsToObservable) {
    boundObservables.set(toObservable, bindings);
  }
} // Synchronizes {@link Observable#_boundProperties} and {@link Observable#_boundObservables}
// with {@link BindChain}.
//
// Assuming the following binding being created
//
// 		A.bind( 'a', 'b' ).to( B, 'x', 'y' );
//
// the following bindings were initialized by {@link Observable#bind} in {@link BindChain#_bindings}:
//
// 		{
// 			a: { observable: A, property: 'a', to: [] },
// 			b: { observable: A, property: 'b', to: [] },
// 		}
//
// Iterate over all bindings in this chain and fill their `to` properties with
// corresponding to( ... ) arguments (components of the binding), so
//
// 		{
// 			a: { observable: A, property: 'a', to: [ B, 'x' ] },
// 			b: { observable: A, property: 'b', to: [ B, 'y' ] },
// 		}
//
// Then update the structure of {@link Observable#_boundObservables} with updated
// binding, so it becomes:
//
// 		Map( {
// 			B: {
// 				x: Set( [
// 					{ observable: A, property: 'a', to: [ [ B, 'x' ] ] }
// 				] ),
// 				y: Set( [
// 					{ observable: A, property: 'b', to: [ [ B, 'y' ] ] },
// 				] )
//			}
// 		} )
//
// @private
// @param {BindChain} chain The binding initialized by {@link Observable#bind}.


function updateBindToBound(chain) {
  var toProperty;

  chain._bindings.forEach(function (binding, propertyName) {
    // Note: For a binding without a callback, this will run only once
    // like in A.bind( 'x', 'y' ).to( B, 'a', 'b' )
    // TODO: ES6 destructuring.
    chain._to.forEach(function (to) {
      toProperty = to.properties[binding.callback ? 0 : chain._bindProperties.indexOf(propertyName)];
      binding.to.push([to.observable, toProperty]);
      updateBoundObservables(chain._observable, binding, to.observable, toProperty);
    });
  });
} // Updates an property of a {@link Observable} with a value
// determined by an entry in {@link Observable#_boundProperties}.
//
// @private
// @param {Observable} observable A observable which property is to be updated.
// @param {String} propertyName An property to be updated.


function updateBoundObservableProperty(observable, propertyName) {
  var boundProperties = observable[boundPropertiesSymbol];
  var binding = boundProperties.get(propertyName);
  var propertyValue; // When a binding with callback is created like
  //
  // 		A.bind( 'a' ).to( B, 'b', C, 'c', callback );
  //
  // collect B.b and C.c, then pass them to callback to set A.a.

  if (binding.callback) {
    propertyValue = binding.callback.apply(observable, binding.to.map(function (to) {
      return to[0][to[1]];
    }));
  } else {
    propertyValue = binding.to[0];
    propertyValue = propertyValue[0][propertyValue[1]];
  }

  if (Object.prototype.hasOwnProperty.call(observable, propertyName)) {
    observable[propertyName] = propertyValue;
  } else {
    observable.set(propertyName, propertyValue);
  }
} // Starts listening to changes in {@link BindChain._to} observables to update
// {@link BindChain._observable} {@link BindChain._bindProperties}. Also sets the
// initial state of {@link BindChain._observable}.
//
// @private
// @param {BindChain} chain The chain initialized by {@link Observable#bind}.


function attachBindToListeners(observable, toBindings) {
  toBindings.forEach(function (to) {
    var boundObservables = observable[boundObservablesSymbol];
    var bindings; // If there's already a chain between the observables (`observable` listens to
    // `to.observable`), there's no need to create another `change` event listener.

    if (!boundObservables.get(to.observable)) {
      observable.listenTo(to.observable, 'change', function (evt, propertyName) {
        bindings = boundObservables.get(to.observable)[propertyName]; // Note: to.observable will fire for any property change, react
        // to changes of properties which are bound only.

        if (bindings) {
          bindings.forEach(function (binding) {
            updateBoundObservableProperty(observable, binding.property);
          });
        }
      });
    }
  });
}
/**
 * An interface which adds "observable properties" and data binding functionality.
 *
 * Can be easily implemented by a class by mixing the {@link module:utils/observablemixin~ObservableMixin} mixin.
 *
 * Read more about the usage of this interface in the:
 * * {@glink framework/guides/architecture/core-editor-architecture#event-system-and-observables "Event system and observables"}
 * section of the {@glink framework/guides/architecture/core-editor-architecture "Core editor architecture"} guide,
 * * {@glink framework/guides/deep-dive/observables "Observables" deep dive} guide.
 *
 * @interface Observable
 * @extends module:utils/emittermixin~Emitter
 */

/**
 * Fired when a property changed value.
 *
 *		observable.set( 'prop', 1 );
 *
 *		observable.on( 'change:prop', ( evt, propertyName, newValue, oldValue ) => {
 *			console.log( `${ propertyName } has changed from ${ oldValue } to ${ newValue }` );
 *		} );
 *
 *		observable.prop = 2; // -> 'prop has changed from 1 to 2'
 *
 * @event change:{property}
 * @param {String} name The property name.
 * @param {*} value The new property value.
 * @param {*} oldValue The previous property value.
 */

/**
 * Fired when a property value is going to be set but is not set yet (before the `change` event is fired).
 *
 * You can control the final value of the property by using
 * the {@link module:utils/eventinfo~EventInfo#return event's `return` property}.
 *
 *		observable.set( 'prop', 1 );
 *
 *		observable.on( 'set:prop', ( evt, propertyName, newValue, oldValue ) => {
 *			console.log( `Value is going to be changed from ${ oldValue } to ${ newValue }` );
 *			console.log( `Current property value is ${ observable[ propertyName ] }` );
 *
 *			// Let's override the value.
 *			evt.return = 3;
 *		} );
 *
 *		observable.on( 'change:prop', ( evt, propertyName, newValue, oldValue ) => {
 *			console.log( `Value has changed from ${ oldValue } to ${ newValue }` );
 *		} );
 *
 *		observable.prop = 2; // -> 'Value is going to be changed from 1 to 2'
 *		                     // -> 'Current property value is 1'
 *		                     // -> 'Value has changed from 1 to 3'
 *
 * **Note:** The event is fired even when the new value is the same as the old value.
 *
 * @event set:{property}
 * @param {String} name The property name.
 * @param {*} value The new property value.
 * @param {*} oldValue The previous property value.
 */

/**
 * Creates and sets the value of an observable property of this object. Such a property becomes a part
 * of the state and is observable.
 *
 * It accepts also a single object literal containing key/value pairs with properties to be set.
 *
 * This method throws the `observable-set-cannot-override` error if the observable instance already
 * has a property with the given property name. This prevents from mistakenly overriding existing
 * properties and methods, but means that `foo.set( 'bar', 1 )` may be slightly slower than `foo.bar = 1`.
 *
 * @method #set
 * @param {String|Object} name The property's name or object with `name=>value` pairs.
 * @param {*} [value] The property's value (if `name` was passed in the first parameter).
 */

/**
 * Binds {@link #set observable properties} to other objects implementing the
 * {@link module:utils/observablemixin~Observable} interface.
 *
 * Read more in the {@glink framework/guides/deep-dive/observables#property-bindings dedicated guide}
 * covering the topic of property bindings with some additional examples.
 *
 * Consider two objects: a `button` and an associated `command` (both `Observable`).
 *
 * A simple property binding could be as follows:
 *
 *		button.bind( 'isEnabled' ).to( command, 'isEnabled' );
 *
 * or even shorter:
 *
 *		button.bind( 'isEnabled' ).to( command );
 *
 * which works in the following way:
 *
 * * `button.isEnabled` **instantly equals** `command.isEnabled`,
 * * whenever `command.isEnabled` changes, `button.isEnabled` will immediately reflect its value.
 *
 * **Note**: To release the binding, use {@link module:utils/observablemixin~Observable#unbind}.
 *
 * You can also "rename" the property in the binding by specifying the new name in the `to()` chain:
 *
 *		button.bind( 'isEnabled' ).to( command, 'isWorking' );
 *
 * It is possible to bind more than one property at a time to shorten the code:
 *
 *		button.bind( 'isEnabled', 'value' ).to( command );
 *
 * which corresponds to:
 *
 *		button.bind( 'isEnabled' ).to( command );
 *		button.bind( 'value' ).to( command );
 *
 * The binding can include more than one observable, combining multiple data sources in a custom callback:
 *
 *		button.bind( 'isEnabled' ).to( command, 'isEnabled', ui, 'isVisible',
 *			( isCommandEnabled, isUIVisible ) => isCommandEnabled && isUIVisible );
 *
 * Using a custom callback allows processing the value before passing it to the target property:
 *
 *		button.bind( 'isEnabled' ).to( command, 'value', value => value === 'heading1' );
 *
 * It is also possible to bind to the same property in an array of observables.
 * To bind a `button` to multiple commands (also `Observables`) so that each and every one of them
 * must be enabled for the button to become enabled, use the following code:
 *
 *		button.bind( 'isEnabled' ).toMany( [ commandA, commandB, commandC ], 'isEnabled',
 *			( isAEnabled, isBEnabled, isCEnabled ) => isAEnabled && isBEnabled && isCEnabled );
 *
 * @method #bind
 * @param {...String} bindProperties Observable properties that will be bound to other observable(s).
 * @returns {Object} The bind chain with the `to()` and `toMany()` methods.
 */

/**
 * Removes the binding created with {@link #bind}.
 *
 *		// Removes the binding for the 'a' property.
 *		A.unbind( 'a' );
 *
 *		// Removes bindings for all properties.
 *		A.unbind();
 *
 * @method #unbind
 * @param {...String} [unbindProperties] Observable properties to be unbound. All the bindings will
 * be released if no properties are provided.
 */

/**
 * Turns the given methods of this object into event-based ones. This means that the new method will fire an event
 * (named after the method) and the original action will be plugged as a listener to that event.
 *
 * Read more in the {@glink framework/guides/deep-dive/observables#decorating-object-methods dedicated guide}
 * covering the topic of decorating methods with some additional examples.
 *
 * Decorating the method does not change its behavior (it only adds an event),
 * but it allows to modify it later on by listening to the method's event.
 *
 * For example, to cancel the method execution the event can be {@link module:utils/eventinfo~EventInfo#stop stopped}:
 *
 *		class Foo {
 *			constructor() {
 *				this.decorate( 'method' );
 *			}
 *
 *			method() {
 *				console.log( 'called!' );
 *			}
 *		}
 *
 *		const foo = new Foo();
 *		foo.on( 'method', ( evt ) => {
 *			evt.stop();
 *		}, { priority: 'high' } );
 *
 *		foo.method(); // Nothing is logged.
 *
 *
 * **Note**: The high {@link module:utils/priorities~PriorityString priority} listener
 * has been used to execute this particular callback before the one which calls the original method
 * (which uses the "normal" priority).
 *
 * It is also possible to change the returned value:
 *
 *		foo.on( 'method', ( evt ) => {
 *			evt.return = 'Foo!';
 *		} );
 *
 *		foo.method(); // -> 'Foo'
 *
 * Finally, it is possible to access and modify the arguments the method is called with:
 *
 *		method( a, b ) {
 *			console.log( `${ a }, ${ b }`  );
 *		}
 *
 *		// ...
 *
 *		foo.on( 'method', ( evt, args ) => {
 *			args[ 0 ] = 3;
 *
 *			console.log( args[ 1 ] ); // -> 2
 *		}, { priority: 'high' } );
 *
 *		foo.method( 1, 2 ); // -> '3, 2'
 *
 * @method #decorate
 * @param {String} methodName Name of the method to decorate.
 */